import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

/**
 * Add-task "date" metadata icon — a calendar glyph on a rounded `#F9FAFB`
 * tile, used as the date picker trigger in the Board add-task creator. The
 * glyph inherits `color()` via `currentColor`; the tile fill is fixed. The six
 * date dots are drawn as circles on the 3x2 grid of the source artwork.
 */
@Component({
  selector: 'lib-add-task-date-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="active() ? '#2970ff' : color()"
      [class]="iconClass()">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
        [attr.fill]="active() ? '#eff6ff' : '#F9FAFB'" />
      <path
        d="M9.33301 7.83398C9.05967 7.83398 8.83301 7.60732 8.83301 7.33398V5.33398C8.83301 5.06065 9.05967 4.83398 9.33301 4.83398C9.60634 4.83398 9.83301 5.06065 9.83301 5.33398V7.33398C9.83301 7.60732 9.60634 7.83398 9.33301 7.83398Z"
        fill="currentColor" />
      <path
        d="M14.667 7.83398C14.3937 7.83398 14.167 7.60732 14.167 7.33398V5.33398C14.167 5.06065 14.3937 4.83398 14.667 4.83398C14.9403 4.83398 15.167 5.06065 15.167 5.33398V7.33398C15.167 7.60732 14.9403 7.83398 14.667 7.83398Z"
        fill="currentColor" />
      <path
        d="M17.6663 10.5605H6.33301C6.05967 10.5605 5.83301 10.3339 5.83301 10.0605C5.83301 9.78721 6.05967 9.56055 6.33301 9.56055H17.6663C17.9397 9.56055 18.1663 9.78721 18.1663 10.0605C18.1663 10.3339 17.9397 10.5605 17.6663 10.5605Z"
        fill="currentColor" />
      <path
        d="M14.6667 19.1673H9.33333C6.9 19.1673 5.5 17.7673 5.5 15.334V9.66732C5.5 7.23398 6.9 5.83398 9.33333 5.83398H14.6667C17.1 5.83398 18.5 7.23398 18.5 9.66732V15.334C18.5 17.7673 17.1 19.1673 14.6667 19.1673ZM9.33333 6.83398C7.42667 6.83398 6.5 7.76065 6.5 9.66732V15.334C6.5 17.2407 7.42667 18.1673 9.33333 18.1673H14.6667C16.5733 18.1673 17.5 17.2407 17.5 15.334V9.66732C17.5 7.76065 16.5733 6.83398 14.6667 6.83398H9.33333Z"
        fill="currentColor" />
      <circle cx="9.667" cy="13" r="0.7" fill="currentColor" />
      <circle cx="12" cy="13" r="0.7" fill="currentColor" />
      <circle cx="14.333" cy="13" r="0.7" fill="currentColor" />
      <circle cx="9.667" cy="15.334" r="0.7" fill="currentColor" />
      <circle cx="12" cy="15.334" r="0.7" fill="currentColor" />
      <circle cx="14.333" cy="15.334" r="0.7" fill="currentColor" />
    </svg>
  `,
})
export class AddTaskDateIconComponent extends BaseIconComponent {
  override width = input<string>('24');
  override height = input<string>('24');
  override viewBox = input<string>('0 0 24 24');
  override color = input<string>('#6B7280');
  /** Active (picker open) state: primary-faint tile + primary glyph. */
  readonly active = input<boolean>(false);
}
